import {axiosInstancePensions} from './wrapper/apiwrapper';
import {v4 as uuidv4} from 'uuid';
  
  
export const NetworkManager ={
  // Get Tax Document List API endpoint.
  getTaxDocumentListData: (token) => {
      const xoacorrelationId = uuidv4();
      return axiosInstancePensions.get(`participants/participant/tax-documents/1099R/years`, {
          headers: {
            'X-OA-CorrelationID': xoacorrelationId,
            Authorization: `Bearer ${token}`
          },
      });
  },
  getTaxDocument: (token, formId) => {
    const xoacorrelationId = uuidv4();
    return axiosInstancePensions.get(
      `participants/participant/tax-documents/1099R/estatement/${formId}`,
      {
        headers: {
          'X-OA-CorrelationID': xoacorrelationId,
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },
}
